const IconDotFilled = () => (
    <span role="img" className="anticon">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
            fill="currentColor"
            width="1em"
            height="1em"
        >
            <path d="M2 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3z"/>
        </svg>
    </span>
);

export default IconDotFilled;